var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userstate"},[(!_vm.hasRegistered)?_c('div',{staticClass:"statebox"},[_vm._v("您还未报名，请点击报名入口报名")]):_c('div',{staticClass:"statebox"},[_vm._v("您已报名成功,信息正在审核中")])])}
var staticRenderFns = []

export { render, staticRenderFns }